import { axiosPrivate } from "../config/axios";
import { errorApi, successApi } from "./handle.response.api";

export const getDetailTripApi = async (tripId: string) => {
  try {
    const res = await axiosPrivate.get(`/trips/${tripId}`);
    return successApi(res?.data);
  } catch (error: any) {
    return errorApi("Lấy chi tiết chuyến đi thất bại", error?.response?.data?.message);
  }
};
